/* eslint-disable react/no-this-in-sfc */
import React from 'react';
import { Form } from '@ant-design/compatible';
import { Erase } from '@carbon/icons-react';
import { Select, Button } from 'antd';

import './filterForm.css';

const FormItem = Form.Item;

function assetsForm() {
    const { form, divisions, tags, vehicleTypes, vehicleMakes, assetOptions, assetTabFilters } = this.props;
    const { getFieldDecorator } = form;

    return (
        <Form
            onSubmit={this.handleSubmit}
            className="login-form"
            layout="vertical"
        >
            <Form.Item label="Asset">
                {getFieldDecorator('asset', {
                    initialValue: assetTabFilters?.asset || null,
                })(
                    <Select
                        mode="multiple"
                        showSearch
                        allowClear={<Erase size={12} />}
                        filterOption={(txt, obj) => (obj.props.children.toLowerCase().includes(txt.toLowerCase()))}
                        placeholder="Select Asset"
                        data-testid='assets-fitler_asset-select'
                    >
                        {assetOptions.map((a) => (
                            <Select.Option
                                key={a.id}
                                value={a.id}
                            >
                                {a.name === a.reg || a.reg === '' ? a.name : `${a.name} [${a.reg}]`}
                            </Select.Option>
                        ))}
                    </Select>,
                )}
            </Form.Item>
            <FormItem label="Division">
                {getFieldDecorator('divisions', {
                    initialValue: assetTabFilters?.divisions || null,
                })(
                    <Select
                        mode="multiple"
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        placeholder="Select Division"
                        allowClear={<Erase size={12} />}
                        showSearch
                        data-testid='assets-filter_division-select'
                    >
                        {divisions.map((v, i) => (
                            /* eslint-disable-next-line react/no-array-index-key */
                            <Select.Option
                                key={`${i}`}
                                value={v.id}
                            >
                                {v.name}
                            </Select.Option>
                        ))}
                    </Select>
                )}
            </FormItem>
            <FormItem label="Tags">
                {getFieldDecorator('tags', {
                    initialValue: assetTabFilters?.tags || null,
                })(
                    <Select
                        mode="multiple"
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        placeholder="Select Tag"
                        allowClear={<Erase size={12} />}
                        showSearch
                        data-testid='assets-filter_tag-select'
                    >
                        {tags.map((v, i) => (
                            <Select.Option
                                key={`${i}`}
                                value={v.id}
                            >
                                {v.name}
                            </Select.Option>
                        ))}
                    </Select>
                )}
            </FormItem>
            <FormItem label="Vehicle type">
                {getFieldDecorator('vehicle_type', {
                    initialValue: assetTabFilters?.vehicle_type || null,
                })(
                    <Select
                        allowClear={<Erase size={12} />}
                        placeholder="Select Vehicle Type"
                        showSearch
                        filterOption={(txt, obj) => (obj.props.children.toLowerCase().includes(txt.toLowerCase()))}
                        data-testid='assets-filter_vehicle-type-select'
                    >
                        {vehicleTypes.map((v, i) => (
                            <Select.Option
                                key={`${i}`}
                                value={v.id.toString()}
                            >
                                {v.title}
                            </Select.Option>
                        ))}
                    </Select>
                )}
            </FormItem>
            <FormItem label="Asset make">
                {getFieldDecorator('make', {
                    initialValue: assetTabFilters?.make || null,
                })(
                    <Select
                        allowClear={<Erase size={12} />}
                        placeholder="Select Make"
                        showSearch
                        filterOption={(txt, obj) => (obj.props.children.toLowerCase().includes(txt.toLowerCase()))}
                        data-testid='assets-filter_make-select'
                    >
                        {vehicleMakes.map((v, i) => (
                            <Select.Option
                                key={`${i}`}
                                value={v.id}
                            >
                                {v.title}
                            </Select.Option>
                        ))}
                    </Select>
                )}
            </FormItem>
            <FormItem label="Fuel type">
                {getFieldDecorator('fuel_type', {
                    initialValue: assetTabFilters?.fuel_type || null,
                })(
                    <Select
                        allowClear={<Erase size={12} />}
                        placeholder="Select Fuel Type"
                        filterOption={(txt, obj) => (obj.props.children.toLowerCase().includes(txt.toLowerCase()))}
                        showSearch
                        data-testid='assets-filter_fuel-type-select'
                    >
                        <Select.Option value="1">Diesel</Select.Option>
                        <Select.Option value="2">Petrol</Select.Option>
                        <Select.Option value="3">Gas</Select.Option>
                        <Select.Option value="4">Electricity</Select.Option>
                        <Select.Option value="5">Hydrogen</Select.Option>
                        <Select.Option value="6">Hybrid</Select.Option>
                    </Select>,
                )}
            </FormItem>
            <div className="mt-2 mb-1 text-center">
                <Button
                    htmlType="submit"
                    type="primary"
                >
                    Filter
                </Button>
            </div>
        </Form>
    );
}

function divisionsForm() {
    const { form, divisions, divisionTabFilters } = this.props;
    const { getFieldDecorator } = form;

    return (
        <Form
            onSubmit={this.handleSubmit}
            className="login-form"
            layout="vertical"
        >
            <FormItem label="Division">
                {getFieldDecorator('divisions', {
                    initialValue: divisionTabFilters?.divisions || null,
                })(
                    <Select
                        mode="multiple"
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        placeholder="Select Division"
                        allowClear={<Erase size={12} />}
                        showSearch
                        data-testid='assets-filter_division-select'
                    >
                        {divisions.map((v, i) => (
                            /* eslint-disable-next-line react/no-array-index-key */
                            <Select.Option
                                key={`${i}`}
                                value={v.id}
                            >
                                {v.name}
                            </Select.Option>
                        ))}
                    </Select>
                )}
            </FormItem>
            <div className="mt-2 mb-1 text-center">
                <Button
                    htmlType="submit"
                    type="primary"
                >
                    Filter
                </Button>
            </div>
        </Form>
    );
}

function tagsForm() {
    const { form, tags, tagsTabFilters } = this.props;
    const { getFieldDecorator } = form;

    return (
        <Form
            onSubmit={this.handleSubmit}
            className="login-form"
            layout="vertical"
        >
            <br />
            <FormItem label="Tags">
                {getFieldDecorator('tag_ids', { // must have different name to avoid conflict with asset filter
                    initialValue: tagsTabFilters?.tag_ids,
                })(
                    <Select
                        mode="multiple"
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        placeholder="Select Tag"
                        allowClear={<Erase size={12} />}
                        showSearch
                        data-testid='tags-filter_tag-select'
                    >
                        {tags.map((v, i) => (
                            <Select.Option
                                key={`${i}`}
                                value={v.id}
                            >
                                {v.name}
                            </Select.Option>
                        ))}
                    </Select>
                )}
            </FormItem>
            <div className="mt-2 mb-1 text-center">
                <Button
                    htmlType="submit"
                    type="primary"
                >
                    Filter
                </Button>
            </div>
        </Form>
    );
}

export { divisionsForm, assetsForm, tagsForm };
